"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSantanderAgreementEnumFields = exports.mapSantanderAgreement = exports.mapSantanderAgreements = void 0;
const utils_1 = require("../../utils");
const mapSantanderAgreements = (agreements, groups = []) => agreements.map((agreement) => (0, exports.mapSantanderAgreement)(agreement, groups));
exports.mapSantanderAgreements = mapSantanderAgreements;
const mapSantanderAgreement = (agreement, groups = []) => {
    const code = agreement.Code;
    const objectGroups = groups
        .filter((group) => group.AgreementCode === code)
        .map((group) => ({
        code: group.ObjectGroupCode,
        name: group.ObjectGroupName,
    }));
    return Object.assign(Object.assign({}, (0, exports.mapSantanderAgreementEnumFields)(agreement)), { code: agreement.Code, description: agreement.Description, objectGroups });
};
exports.mapSantanderAgreement = mapSantanderAgreement;
const mapSantanderAgreementEnumFields = (agreement) => ({
    applicableForApplicantType: (0, utils_1.mapSantanderCustomerTypeToEnum)(agreement.ApplicableForApplicantType),
    financingType: (0, utils_1.mapSantanderFinancingTypeToEnum)(agreement.ProductType),
});
exports.mapSantanderAgreementEnumFields = mapSantanderAgreementEnumFields;
//# sourceMappingURL=agreement.js.map